import { render, staticRenderFns } from "./AmazonRiver.vue?vue&type=template&id=4cd48862&"
import script from "./AmazonRiver.vue?vue&type=script&lang=js&"
export * from "./AmazonRiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports